var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBinSvgrepoCom11({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 7.57205C9.54898 5.28588 16.4511 5.28588 22.75 7.57205",
    stroke: "#FF7C05",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.67773 6.19661C8.67773 5.04734 9.13427 3.94521 9.94693 3.13255C10.7596 2.3199 11.8618 1.86328 13.0111 1.86328C14.1603 1.86328 15.2626 2.3199 16.0752 3.13255C16.8878 3.94521 17.3444 5.04734 17.3444 6.19661",
    stroke: "#FF7C05",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 14.084V19.5007",
    stroke: "#FF7C05",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5827 10.8223L19.8568 19.4889C19.7404 20.66 19.1987 21.7478 18.3343 22.5464C17.4698 23.345 16.3426 23.7989 15.166 23.8223H10.8327C9.65606 23.7989 8.52882 23.345 7.66438 22.5464C6.79992 21.7478 6.25825 20.66 6.14186 19.4889L5.41602 10.8223",
    stroke: "#FF7C05",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinSvgrepoCom11);
export default __webpack_public_path__ + "static/media/bin-svgrepo-com 11.c7d4075ae4a32b4a6f742ac72bb9af4e.svg";
export { ForwardRef as ReactComponent };